import React from 'react';
import { ItemProps } from './types';

export const Item = ({ item, getItemsLabel }: ItemProps): JSX.Element => <>{getItemsLabel(item)}</>;
